import * as types from "../types/recommendedFoods"

const initialState = {
  contractId: "",
  branchId: "",
  foodIds: [],
  optionIds: []
}

const recommendedFoodsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_RECOMMENDED_FOODS:
      return [...action.recommendedFoods]
    case types.ADD_RECOMMENDED_FOODS:
      return [...action.addedRecommendedFoods]
    case types.UPDATE_RECOMMENDED_FOODS:
      return [...action.updatedRecommendedFoods]
    case types.DELETE_RECOMMENDED_FOODS:
      return {
        contractId: "",
        branchId: "",
        foodIds: [],
        optionIds: []
      }
    default: return state
  }
}

export default recommendedFoodsReducer